import styled from 'styled-components';
import { breakpoints } from 'styles';

export const ThreeColumnGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0 4px;
  align-items: center;
  padding: 0 0 20px 0px;
`;

export const ButtonGrid = styled.div`
  display: flex;
  gap: 1px;

  @media (max-width: ${breakpoints.l}px) {
    width: 100%;
    justify-content: flex-end;
  }
`;
